import BaseAPI from '@/apis/base/baseApi';
import httpClient from '@/apis/base/httpclient';

class ScheduleLogAPI extends BaseAPI {
	constructor() {
		super();
	}
	apiName = 'Business';
	controllerName = 'schedulelog';
}

export default new ScheduleLogAPI();
